// The dashboard and the modules it imports are not needed to show the login page. They are loaded
// once, early when a session is likely, and again after a failed download.
let dashboardModule: Promise<typeof import("../components/Dashboard")> | null = null;

export function loadDashboard() {
  dashboardModule ??= import("../components/Dashboard").catch((error: unknown) => {
    dashboardModule = null;
    throw error;
  });
  return dashboardModule;
}

export function preloadDashboard() {
  void loadDashboard().catch(() => undefined);
}
